import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import testwrap from 'assets/icons/brain.png'
import { getSurveyData } from "service/SurveyService";
import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import styles from "./SurveyBody.module.scss";
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
import { Icon } from '../../../components/UnvUI/Icons'
const SurveyBody = ({ data, isadmin, log=null }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate()
 
  const [render, setRender] = useState(false)


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {

    setRender(false)

  }, [render]);

  const handleClick = (id) => {
    if (typeof id !== "undefined") {
      navigate(`/survey/`, { state: { usedId: id } });
    }
  };
  const handleClickSurvey = (id) => {
    if (typeof id !== "undefined") {
      navigate(`/usesurvey/`, { state: { usedId: id } });
    }
  };

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return `${t('survey.today_word')} ${date.format('HH:mm')}`;
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <div>
      {data?.length === 0 ? (
        <div style={{
          padding: '48px 24px',
          textAlign: 'center',
          background: '#FFFFFF',
          borderRadius: '12px',
          border: '2px solid #F5F5F5'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            background: 'var(--color-accent-light)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px'
          }}><Icon name="chart" /></div>
          <h3 style={{ color: '#333333', margin: '0 0 12px 0', fontSize: '20px', fontWeight: '700' }}>
            {log === 0 ? t('survey.no_completed_surveys') : isadmin ? t('survey.no_created_surveys') : t('survey.no_available_surveys')}
          </h3>
          <p style={{ color: '#999999', margin: 0, fontSize: '15px' }}>
            {isadmin && log !== 0 ? t('survey.create_first_survey') : t('survey.no_surveys_in_section')}
          </p>
        </div>
      ) : (
        <div className={styles.survey_card_wrapper}>
          <div className={styles.survey_table_header}>
            <span>{t('survey.col_name')}</span>
            {log !== 0 && isadmin && <span>{t('survey.col_status')}</span>}
            {log === 0 && <span>{t('survey.col_time')}</span>}
            <span>{log === 0 ? t('survey.col_author') : t('survey.col_date')}</span>
            <span>{t('survey.col_actions')}</span>
          </div>
      {(log === 0) ? (
        <>  
          {[...data].map((item) => (
            <div key={item.id || item.survey} className={styles.survey_card}>
              <div>
                <p className={styles.title_survey}>
                  <img src={testwrap} className={styles.img} alt={t('survey.survey_alt')} />
                  {item.employee_part_survey_title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              <div className={styles.date_info}>
                <p className={styles.date_text}><Icon name="timer" /> {item.time_response}</p>
              </div>
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
              </div>
              <div className={styles.action_buttons}>
                <button
                  className={styles.open_btn}
                  onClick={() => handleClickSurvey(item.survey)}
                >
                  {t('survey.view_btn')}
                </button>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {[...data].map((item) => (
            <div key={item.id} className={styles.survey_card}>
              <div>
                <p className={styles.title_survey}>
                  <img src={testwrap} className={styles.img} alt={t('survey.survey_alt')} />
                  {item.title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              {isadmin && (
                <div>
                  <span className={`${styles.status_badge} ${item.activate ? styles.active : styles.inactive}`}>
                    <img
                      src={item.activate ? openicon : closeicon}
                      className={styles.img_status}
                      alt={item.activate ? t('survey.status_open') : t('survey.status_closed')}
                    />
                    {item.activate ? t('survey.status_open') : t('survey.status_closed')}
                  </span>
                </div>
              )}
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
                <p className={styles.date_text}>{formatDate(item.createdAt)}</p>
              </div>
              <div className={styles.action_buttons}>
                {isadmin ? (
                  <button
                    className={styles.open_btn}
                    onClick={() => handleClick(item.id)}
                  >
                    {t('survey.watch_btn')}
                  </button>
                ) : (
                  <button
                    className={styles.open_btn}
                    onClick={() => handleClickSurvey(item.id)}
                  >
                    {t('survey.pass_btn')}
                  </button>
                )}
              </div>
            </div>
          ))}
        </>
      )}
        </div>
      )}
    </div>
  );
};

export default SurveyBody;
